<template>
    <!-- Content Header (Page header) -->
    <div class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h1 class="m-0">Pagos</h1>
                </div><!-- /.col -->
                <div class="col-sm-6">
                    <ol class="breadcrumb float-sm-right">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">
                                Home
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active">Pagos</li>
                    </ol>
                </div><!-- /.col -->
            </div><!-- /.row -->
        </div><!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header border-0">
                            <div class="d-flex justify-content-between">
                                <h3 class="card-title">Lista de Pagos</h3>
                                <PrimaryButton class="btn btn-primary" data-toggle="modal" data-target="#modal-lg"
                                    @click="openCreationForm">
                                    Registrar pago
                                </PrimaryButton>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="position-relative col-sm-12">
                                <Modal :customClass="modalContent === 2 || modalContent === 3 || modalContent === 4 ? 'modal-xl' : 'modal-lg'">
                                    <AddPaymentForm v-if="modalContent == 1"
                                        :client="selectedClient" 
                                        :disposition="selectedDisposition"
                                        :amortizatiobPayment="selectedAmortization"
                                        :quotation="getQuotation"
                                        :temp-values="tempValues" @show-table="showTable($event)"
                                        @close-modal="modalStatus" @change-modal-content="modalContent = $event">
                                    </AddPaymentForm>

                                    <div v-if="modalContent === 2">
                                        <ClientsMinTable 
                                            @back-to-form="backToForm($event)"
                                            @selectClient="selectedClient = $event"
                                            :list="getAllClients"
                                            :itemsPerPage="itemsPerPageModal" 
                                            :currentPage="currentPageModal">
                                        </ClientsMinTable>
                                        <Pagination :list="getAllClients" :itemsPerPage="itemsPerPageModal"
                                            :currentPage="currentPageModal" @current-page="currentPageModal = $event">
                                        </Pagination>
                                    </div>

                                    <div v-if="modalContent === 3">
                                        <DispositionTable 
                                            :list="getCreditFacilities"
                                            @selected-item="selectedDisposition = $event"
                                            @back-to-form="backToForm($event)"
                                            :currentPage="currentPageModal"
                                            :itemsPerPage="itemsPerPageModal">
                                        </DispositionTable>
                                        <Pagination :list="getCreditFacilities" :itemsPerPage="itemsPerPageModal"
                                            :currentPage="currentPageModal" @current-page="currentPageModal = $event">
                                        </Pagination>
                                    </div>

                                    <div v-if="modalContent === 4">
                                        <AmortizationPaymentTable
                                            :amortization-data="getQuotation"
                                            @selected-amortization-payment="selectedAmortization = $event"
                                            @back-to-form="backToForm($event)"
                                        />
                                    </div>
                                </Modal>
                            </div>
                        </div>
                    </div>
                    <!-- /.card -->
                </div>
            </div>
            <!-- /.row -->
        </div>
        <!-- /.container-fluid -->
    </div>
    <!-- /.content -->
</template>

<!--Option API-->
<script>
import { mapState, mapActions, mapGetters } from 'pinia';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import DisbursementsTable from '@/Components/Tables/DisbursementsTable.vue';
import Pagination from '@/Components/Bootstrap/Pagination.vue';
import Modal from '@/Components/Bootstrap/Modal.vue';
import AddPaymentForm from '@/Components/Forms/Payments/Form.vue';
import ClientsMinTable from '@/Components/Tables/ClientsMinTable.vue';
import DispositionTable from '@/Components/Tables/DispositionMinTable.vue';
import EditForm from '@/Components/Forms/Disbursements/Edit.vue';
import ProspectsTable from '@/Components/Tables/ProspectsMinTable.vue';
import LoanApplicationsTable from '@/Components/Tables/LoanApplicationsMinTable.vue';
import { useIndividualProspectsStore } from "@/pinia/Prospects/individual.module";
import { sharedStore } from '@/pinia/sharedStore.module';
import { useCreditFacilities } from '@/pinia/creditFacilities.module';
import { useQuotationsStore } from '@/pinia/quotations.module';

import { useClientsStore } from '@/pinia/clients.module';

import AmortizationPaymentTable from '@/Components/Tables/AmortizationPaymentTable.vue'
import { event } from 'jquery';

export default {
    components: {
        PrimaryButton,
        DisbursementsTable,
        Pagination,
        Modal,
        AddPaymentForm,
        ClientsMinTable,
        DispositionTable,
        EditForm,
        ProspectsTable,
        LoanApplicationsTable,
        AmortizationPaymentTable
    },
    data() {
        return {
            modalContent: 0,
            editing: false,
            currentPageModal: 1,
            itemsPerPageModal: 10,
            tempValues: {},
            selectedClient: new Object({}),
            selectedDisposition: {},
            selectedLoanApplication: {},
            selectedCreditFacility: {},
            selectedAmortization: []
        }
    },
    computed: {
        ...mapState(useClientsStore, ['getAllClients']),
        ...mapState(sharedStore, ['getAllProspects', 'getLoanApplications']),
        ...mapState(useCreditFacilities, ['itemsPerPage', 'currentPage', 'searchString', 'getCreditFacilities']),
        ...mapState(useQuotationsStore, ['getQuotation']),
        ...mapGetters(useCreditFacilities, ['paginatedS', 'filteredS']),
        addNewRecord() {
            return this.$getLocaleMessage('buttons', 'addNewRecord')
        },
        paginatedCreditFacilities() {
            return this.paginatedS;
        },
        searchStringModel: {
            get() {
                return this.$pinia.state.value.creditFacilities?.searchString || '';
            },
            set(value) {
                this.setSearchString(value);
            }
        }
    },
    methods: {
        ...mapActions(useIndividualProspectsStore, ['fetchActiveMixedProspects']),
        ...mapActions(sharedStore, ['setSelectedProspectus', 'setSelectedLoanApplication', 'resetProspectsList', 'resetLoanApplicationsList']),
        ...mapActions(useCreditFacilities, ['fetchCreditFacilities', 'sortBy', 'setCurrentPage', 'setSearchString', 'fetchCreditFacilitiesByProspect']),
        ...mapActions(useClientsStore, ['fetchClients', 'setSelectedClient']),
        ...mapActions(useQuotationsStore, ['getHistoryQuotation']),
        openCreationForm() {
            this.modalContent = 1;
            this.editing = false;
            //#1 Carga de prospectos
            this.fetchActiveMixedProspects();
            this.fetchClients();
        },
        openEditionForm(creditFacility) {
            this.selectedCreditFacility = creditFacility;
            this.modalContent = 4;
            this.editing = true
        },
        showTable(data) {

            /**Identificamos que se cambia la selección del prospecto y entonces limpiamos el contenido del formulario para seleccionar nuevos valores */
            if(data.contentNumber === 2){
                this.selectedLoanApplication = {};
                this.setSelectedLoanApplication();
                this.resetLoanApplicationsList();
            }

            this.tempValues = data;
            this.modalContent = data.contentNumber;
        },
        modalStatus(status) {
            if (status) {
                $('#modal-lg').modal('hide');
            }
        },
        backToForm() {
            //this.modalContent = this.editing ? 4 : 1;
            this.$nextTick(() => {
                this.modalContent = 1;
            });
        }
    },
    watch: {
        selectedClient: {
            async handler(newItem) {
                if (newItem && newItem.id !== 0) {

                   this.setSelectedClient(newItem.id);
                   this.selectedDisposition = {};
                   this.selectedAmortization = [];

                   if (newItem?.creditFacility?.prospectus?.prospectusId) {
                        try {
                            await this.fetchCreditFacilitiesByProspect(newItem?.creditFacility?.prospectus?.prospectusId);
                        } catch (error) {
                            console.error('Error cargando disposiciones:', error);
                        }
                    }
                }
            },
            immediate: true,
        },
        selectedDisposition: {
            async handler(newItem) {
                this.selectedAmortization = [];
                if (newItem.prospectus?.prospectusId && newItem.loanApplication?.quotations?.id) {
                    try {
                        const request = {
                            prospect: newItem.prospectus?.prospectusId,
                            quote: newItem?.loanApplication?.quotations?.id
                        };
                        await this.getHistoryQuotation(request);
                    } catch (error) {
                        console.error('Error cargando amortización:', error);
                    }
                }
            },
            immediate: true,
        },
        selectedAmortization: {
            handler(newItem) {
                /* if (newItem && newItem.id !== null && newItem.id !== undefined) { //&& newItem.personTypeId !== null && newItem.personTypeId !== undefined
                    this.setSelectedLoanApplication(newItem.id);
                } */
                /*if (disposition?.loanApplication?.quotationId) {
                    await this.getHistoryQuotation(disposition.loanApplication.quotationId)
                }*/
            },
            immediate: true,
        }
    },
    mounted() {
        $('#modal-lg').on('hidden.bs.modal', () => {
            this.modalContent = 0;
            this.editing = false;

            // 1️⃣ Limpiar selección de cliente
            this.selectedClient = {};

            // 2️⃣ Limpiar disposición
            this.selectedDisposition = {};

            // 3️⃣ Limpiar solicitud
            this.selectedLoanApplication = {};
            
            this.selectedAmortization = [];

            // 4️⃣ Limpiar valores temporales
            this.tempValues = {};

            // 5️⃣ Limpiar stores relacionados
            this.setSelectedProspectus();
            this.resetProspectsList();
            this.setSelectedLoanApplication();
            this.resetLoanApplicationsList();


            console.log("Formulario limpiado al cerrar modal");
        });
    }

}
</script>